import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve a media URL. Absolute URLs pass through; relative paths (like /api/uploads/...) get prefixed with the backend origin.
export const resolveMediaUrl = (url) => {
  if (!url) return "";
  if (/^(https?:|data:)/i.test(url)) return url;
  return `${BACKEND_URL}${url}`;
};

// httpOnly cookie–based auth: send credentials on every request.
const client = axios.create({ baseURL: API, withCredentials: true });

export default client;
